var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div style="display:none;padding-left:1.618rem"class="page-small-announcement"data-bind="visibleAnimated: WorkingState() === \'submit\'"> <div class="margin-bottom-ms-2"> <h3>Ваше обращение успешно отправлено, ему присвоен №&nbsp;<span data-bind="text: ComplaintId">C-00000</span></h3> </div> <a href="http://www.rgs.ru/"data-bind="visible:!EmployeeMode(), attr: { href: HomeUrl() }">Вернуться на главную</a> <a href="/feedback.wbp"data-bind="visible:EmployeeMode()">Зарегистрировать новое обращение</a> </div>';
}
return __p;
};
